/**
 * Inline writeback QC issues under a BO write-back note, mirroring the
 * comments writeback validation modal list for the same report row.
 *
 * @module busniessOffice/components/singleComment/WritebackQcBelowNote
 */

import ValidationIssueItem from "../../../../../../components/modals/commentsWritebackValidationModal/ValidationIssueItem";
import { TemplateValidatorIssue } from "../../../../../../data-model/templateValidatorModel";

interface WritebackQcBelowNoteProps {
  reportId: string;
  issues: TemplateValidatorIssue[];
}

/**
 * Renders validation issues below the write-back textarea when the modal
 * flow has populated {@link writebackQcByReportId} for this report.
 *
 * @param props - Report id and issue list
 * @returns Section with divider and issue list, or null when there are no issues
 */
const WritebackQcBelowNote = (props: WritebackQcBelowNoteProps) => {
  const { issues } = props;
  if (!issues.length) {
    return null;
  }

  return (
    <div
      className="writeback-qc-below-note border-t border-primaryGray-14 px-3 py-2.5"
      data-writeback-qc-report-id={props.reportId}
    >
      <ul className="list-none space-y-2 pl-0">
        {issues.map((issue, idx) => (
          <ValidationIssueItem
            key={`${props.reportId}-qc-${idx}`}
            issue={issue}
          />
        ))}
      </ul>
    </div>
  );
};

export default WritebackQcBelowNote;
